import NotFound from 'components/NotFound';
const Index = () => {
  return <NotFound />;
};

export default Index;
